var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2L12 22M2 12L22 12","stroke":"currentColor","strokeWidth":"1.5625","strokeLinecap":"round"}));
}

IconPlus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
